import { Swiper, Navigation, Pagination } from 'swiper';
import elementExists  from "../../core/utils/element-exists";

const RecipeCategories = function(){

    // Get Data with AJAX
    const containers = document.querySelectorAll( "[data-tag-count]");
    if( elementExists( containers, true )){
        containers.forEach( container => {
            const data = container.dataset;
            const url = data.url.replace(  'tags'  , data.tags  );
            fetch( url )
            .then( res => {
                if( res.ok ){
                    return res.text();
                }
                return false;
            })
            .then( text => {
                if( text ){
                    container.innerHTML = text;
                }
            })
        });
    }
}
export default RecipeCategories;
